import { useState } from 'react';
import { Box, SvgIcon } from '@mui/material';
import { ReactComponent as ImageIcon } from '../../icons/picture.svg';

export interface IPremMealImageProps {
    url: string;
    width?: number | string;
    height?: number | string;
    onClick?: (src: string, event: React.MouseEvent<HTMLElement>) => void;
}

// The flight report files are served from an absolute URL (FlightReportFile.Url).
// The URL is used directly as the <img> source without prepending any prefix.
function PremMealImage({ url, width = 110, height = 110, onClick }: IPremMealImageProps) {
    const [error, setError] = useState<boolean>(false);

    if (error || !url) {
        return (
            <Box sx={{ width, height, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 2, backgroundColor: 'action.hover', color: 'text.disabled' }}>
                <SvgIcon component={ImageIcon} inheritViewBox />
            </Box>
        );
    }

    return (
        <Box
            component='img'
            src={url}
            alt={url}
            onError={() => setError(true)}
            onClick={(e) => onClick?.(url, e)}
            sx={{ width, height, objectFit: 'cover', borderRadius: 2, cursor: onClick ? 'pointer' : 'default' }}
        />
    );
}

export default PremMealImage;
